(ns hai.tasks.mini-app
  "The tasks mini-app card shared by the home dashboard (and later the
   extension sidebar): the mini-app frame with the perforation shifted right
   and the tasks-tinted header bar. Mirrors [[hai.notes.mini-app]]."
  (:require
   [hai.mini-apps.frame :as frame]
   [hai.tasks.header :as header]
   [lambdaisland.ornament :as o]))

(o/defstyled card frame/card
  [:&::before {:left "auto" :right "40px"}]
  [header/bar
   {:border-top-left-radius "16px"
    :border-top-right-radius "16px"}]
  ;; Collapsed, the bar is the whole card, so it rounds its bottom corners too.
  [:&.collapsed
   [header/bar
    {:border-bottom-left-radius "16px"
     :border-bottom-right-radius "16px"}]]
  ;; Rows float as inset cards rather than a bordered list, so the raised ones
  ;; read as pressable. The gap separates them now that every card is bordered,
  ;; and it is the room a raised card's sheets need underneath — the shell
  ;; carries no margin of its own. Same 8px the board's lanes use. The inset
  ;; holds them off the section edges and gives the drop shadows room.
  [:.section-tasks
   {:display "flex" :flex-direction "column" :gap "8px"
    :padding "4px 14px 16px"}]
  ;; The shared frame clips the last section to round the card's bottom; with
  ;; inset floating cards there is nothing to clip, and the clip would eat their
  ;; shadows and hover-lift. Let it overflow instead.
  [frame/section
   [:&:last-child
    {:overflow "visible"}
    ;; Without that clip a collapsed last section sits on the card's bottom edge
    ;; with nothing rounding it, so its hover fill rounds its own corners. Open,
    ;; the rows are what reach the edge and the toggle stays square.
    [frame/section-toggle
     ["&:not(.open)"
      {:border-bottom-left-radius "16px"
       :border-bottom-right-radius "16px"}]]]])
